import styled from 'styled-components';

export const StyledLabelContainer = styled.div`
  margin-bottom: 15px;
`;